import * as React from 'react';
import './panels.css';
import { default as Renderers } from '../sys/columns';
// import { Segment } from 'semantic-ui-react';
const classnames = require('classnames');

interface State {
    activeItem: number;
}

interface Props {
    className ?: string;
    data ?: any[];
    onClick ?: (asset: {}, index: number) => void;
    header ?: string;
    activeTs: number;
}

export default class TimeStampPanel extends React.Component<Props, State> {

    public static defaultProps: Partial<Props> = {
        activeTs: 0
    };

    handleIndexChanged() {
        // update index of selected item
        this.setState({
            activeItem: this.props.activeTs
        });
    }

    componentWillMount() {
        this.setState({
            activeItem: 0
        });
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (this.props.activeTs !== prevProps.activeTs) {
            this.handleIndexChanged();
        }
    }

    sortByTimestamp(array: Array<any>, key: any) {
        if (this.props.header === 'Interval') {
            return array.sort((a: number, b: number) => {
                let x = a[key]; let y = b[key];
                return ((x > y) ? -1 : ((x < y) ? 1 : 0));
            });
        } else {
            return array;
        }
    }

    onTimeStampClick(ts: number, i: number) {
        this.setState({
           activeItem: ts
        });
        if (this.props.onClick) {
            this.props.onClick(ts, i);
        }
    }

    render() {
        const tabIndex = -1;
        return (
            // tslint:disable-next-line:no-unused-expression
            <div
                className={classnames('panel asset-panel', this.props.className)}
                style={{ overflowY: 'hidden' }}
            >
                <div className="column-header"  >{this.props.header}</div>
                <div style={{ height: '740px', overflow: 'scroll' }}>
                {this.props.children}
                {(this.state && this.props.data) ? this.sortByTimestamp(this.props.data, 'timestamp').map((asset: any, i: number) => {
                    return(
                        <div
                            key={(asset.timestamp) ? asset.timestamp : asset.time}
                            className={(asset.timestamp) ? `card${this.state.activeItem === asset.timestamp ? ' selected' : ''}` : `card${this.state.activeItem === asset.time ? ' selected' : ''}`}
                            tabIndex={tabIndex}
                            onClick={(asset.timestamp) ? () => this.onTimeStampClick(asset.timestamp, i) : () => this.onTimeStampClick(asset.time, i)}
                        >
                            {(asset.timestamp) ? Renderers.timestamp.format(asset.timestamp) : Renderers.timestamp.format(asset.time)}
                        </div>
                    );
                }) : null}
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/panels/timestampPanel.tsx